import { useEffect as d } from "react";
const i = ({
  refs: e,
  onClickOutside: t
}) => {
  const n = (o) => {
    e.some((r) => r.current?.contains(o.target)) || o.defaultPrevented || t();
  };
  d(() => (window.addEventListener("mousedown", n), () => {
    window.removeEventListener("mousedown", n);
  }), [t, e]);
};
export {
  i as useClickOutside
};
